import React, { Component } from "react";
import {
  profile,
  alert,
  toFixed,
  format_date,
  GET,
  POST,
  loading,
  Select,
  Navbar,
} from "../../components/CustomComponent.js";
import Dropdown from "react-bootstrap/Dropdown";

// VAT คิดจากยอดคอมมิชชันเต็ม
const VAT_RATE = 0.07;

// แตกยอดคอมมิชชันออกเป็น VAT / รายได้สุทธิ ให้ทุกที่ใช้ค่าชุดเดียวกัน
const breakdown = (devCommission) => {
  const commission = Number(devCommission) || 0;
  const vat = commission * VAT_RATE;

  return { commission, vat, revenue: commission - vat };
};

export default class Profits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_currency: "THB",
      // ปีเริ่มต้นคือปีปัจจุบัน ดึงทั้งปีในครั้งเดียว (page = 0) จึงไม่มี pagination
      filter_year: new Date().getFullYear(),
      data: [],
      recalc_uid: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get();
  }
  Get = async () => {
    const { filter_currency, filter_year } = this.state;
    let data = [];
    loading(true);
    let [result] = await Promise.all([
      GET("profits/monthly-dev", {
        page_size: 100000,
        page: 0,
        currency: filter_currency,
        year: String(filter_year),
      }),
    ]);
    if (result?.status) {
      data = result.data;
    }
    this.setState({ data });
    loading(false);
  };
  Approve = async (uid) => {
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Are you sure you want to approve this item?",
        "confirm",
        "cancel"
      )
    ) {
      loading(true);
      let result = await POST(`profits/payment`, {
        type: "commission-dev",
        uid_list: [uid],
      });
      if (result?.status) {
        alert("", "success");
        this.Get();
      }
      loading(false);
    }
  };
  Recalculate = async (item) => {
    if (
      await alert(
        "",
        "info",
        "Recalculate",
        `Recalculate ${item.month}/${item.year} ${item.currency || this.state.filter_currency} report?`,
        "confirm",
        "cancel"
      )
    ) {
      this.setState({ recalc_uid: item.uid });
      loading(true);
      const result = await POST("v1/admin/profits/monthly-dev/recalc", { uid: item.uid });
      if (result?.status) {
        alert("", "success", "Success", "Monthly totals have been recalculated.");
        this.Get();
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
      this.setState({ recalc_uid: "" });
    }
  };
  render() {
    const { filter_currency, filter_year, data, recalc_uid } = this.state;
    const rows = Array.isArray(data) ? data : [];
    const yearOptions = [];
    const nowYear = new Date().getFullYear();
    for (let y = nowYear; y >= nowYear - 6; y--) {
      yearOptions.push({ value: y, label: String(y) });
    }
    // Period แสดงเป็น "วัน เดือน ปี" ตัวหนา + เวลาจาง จากข้อมูล start/end เดิม
    const periodPart = (v) =>
      v
        ? {
            date: format_date(v, "dd mmm yyyy", "en"),
            time: format_date(v, "hh:mm", "en"),
          }
        : null;
    const canAct = profile.user_type !== "accounting";
    const colCount = canAct ? 11 : 10;
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];
    const monthShort = (m) =>
      Number(m) >= 1 && Number(m) <= 12 ? monthNames[Number(m) - 1].slice(0, 3) : m;
    const currency = global.currency?.find((c) => c.currency_code === filter_currency);
    const num = (v) => Number(v) || 0;
    const sum = rows.reduce(
      (acc, item) => {
        const b = breakdown(item.dev_commission);
        acc.amount += num(item.amount);
        acc.fee += num(item.fee);
        acc.cost += num(item.cost_gateway);
        acc.commission += b.commission;
        acc.vat += b.vat;
        acc.revenue += b.revenue;
        return acc;
      },
      { amount: 0, fee: 0, cost: 0, commission: 0, vat: 0, revenue: 0 }
    );
    const paidCount = rows.filter((e) => e.status_payment === "success").length;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* ===== Hero ===== */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Commission Dev</div>
                <div className="ar-title">Developer Reports</div>
                <div className="ar-subtitle">
                  Developer commission tracking and monthly reports. VAT 7% is
                  deducted from the full commission.
                </div>
              </div>
              <div className="text-end">
                <div className="ar-year">{filter_year}</div>
                <div className="ar-year-caption">
                  <span className="ar-caption-chip ms-2">
                    {rows.length} period{rows.length === 1 ? "" : "s"}
                  </span>
                </div>
              </div>
            </div>

            <div className="ar-toolbar ar-filter mt-4">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{""}</span>Filter
                </span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Year</span>
                  <Select
                    className="form-control"
                    placeholder="Year"
                    options={yearOptions}
                    value={filter_year}
                    default={false}
                    onChange={(v) => {
                      this.setState({ filter_year: Number(v) }, () => this.Get());
                    }}
                  />
                </div>
              </div>
              <div className="ar-filter-foot">
                <div className="d-flex align-items-center gap-2">
                  {global.currency?.map((item) => (
                    <button
                      key={`currency-${item.currency_code}`}
                      className={`ar-pill ${
                        item.currency_code === filter_currency ? "active" : ""
                      }`}
                      onClick={() => {
                        this.setState({ filter_currency: item.currency_code }, () => {
                          this.Get();
                        });
                      }}
                    >
                      {item.image}
                      <span className="ms-1">{item.currency_code}</span>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* ===== Table ===== */}
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{""}</span>
                  Monthly Developer Commission
                </div>
                <div className="ar-table-caption">
                  {filter_year} · {filter_currency} · {rows.length} period
                  {rows.length === 1 ? "" : "s"} · {paidCount} paid
                </div>
              </div>
              <div className="d-none d-md-flex align-items-center gap-3 ar-legend">
                <span>
                  <span className="pu-legend-dot on" />
                  Paid
                </span>
                <span>
                  <span className="pu-legend-dot off" />
                  Unpaid
                </span>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover text-nowrap ar-table pu-table">
                <thead>
                  <tr>
                    <td className="text-center">Year</td>
                    <td className="text-center">Month</td>
                    <td className="text-center">Period</td>
                    <td className="text-end ar-group-start">Amount</td>
                    <td className="text-end">Fee</td>
                    <td className="text-end">Cost</td>
                    <td className="text-end ar-group-start">Commission</td>
                    <td className="text-end">Vat 7%</td>
                    <td className="text-end ar-head-profit">Revenue</td>
                    <td className="text-center">Paid</td>
                    {canAct && <td className="text-center td-actions">Actions</td>}
                  </tr>
                </thead>
                <tbody>
                  {rows.map((item, index) => {
                    const { commission, vat, revenue } = breakdown(item.dev_commission);
                    const isPaid = item.status_payment === "success";
                    return (
                      <tr key={item.uid || `array-${index}`}>
                        <td data-label="Year" className="text-center ar-muted">
                          {item.year}
                        </td>
                        <td data-label="Month" className="text-center">
                          <div className="ar-month-badge justify-content-center">
                            <span>{monthShort(item.month)}</span>
                          </div>
                        </td>
                        <td data-label="Period">
                          {(() => {
                            const s = periodPart(item.start_date);
                            const e = periodPart(item.end_date);
                            return (
                              <div className="pu-range">
                                <span className="pu-range-part">
                                  <b>{s?.date || "-"}</b>
                                  {s && <small>{s.time}</small>}
                                </span>
                                <span className="pu-range-arrow icon">{""}</span>
                                <span className="pu-range-part">
                                  <b>{e?.date || "-"}</b>
                                  {e && <small>{e.time}</small>}
                                </span>
                              </div>
                            );
                          })()}
                        </td>
                        <td data-label="Amount" className="text-end ar-group-start">
                          {item.amount ? toFixed(item.amount, 2) : "00.00"}
                        </td>
                        <td data-label="Fee" className="text-end ar-muted">
                          {item.fee ? toFixed(item.fee, 2) : "00.00"}
                        </td>
                        <td data-label="Cost" className="text-end ar-muted">
                          {item.cost_gateway ? toFixed(item.cost_gateway, 2) : "00.00"}
                        </td>
                        <td data-label="Commission" className="text-end ar-group-start pu-commission">
                          {toFixed(commission, 2)}
                        </td>
                        <td data-label="Vat 7%" className="text-end ar-neg">
                          {toFixed(vat, 2)}
                        </td>
                        <td data-label="Revenue" className="text-end ar-dep-profit fw-bold">
                          {toFixed(revenue, 2)}
                        </td>
                        <td data-label="Paid" className="text-center">
                          <span className={`pr-status ${isPaid ? "on" : "off"}`}>
                            {isPaid ? "Paid" : "Unpaid"}
                          </span>
                        </td>
                        {canAct && (
                          <td data-label="Actions" className="text-center td-actions">
                            {/* รอบที่จ่ายแล้ว recalc ไม่ได้ ฝั่ง backend ก็ปฏิเสธเช่นกัน */}
                            {isPaid ? (
                              <span className="pu-none">—</span>
                            ) : (
                              <Dropdown align="end">
                                <Dropdown.Toggle className="pu-action-toggle" id={`monthly-devs-actions-${index}`}>Action</Dropdown.Toggle>
                                <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                                  <Dropdown.Item
                                    className={`pu-action-item monthly-devs.update ${
                                      recalc_uid === item.uid ? "opacity-50 pe-none" : ""
                                    }`}
                                    onClick={() => {
                                      this.Recalculate(item);
                                    }}
                                  >
                                    <span className="icon">{""}</span>Recalculate
                                  </Dropdown.Item>
                                  <div className="pu-action-sep" />
                                  <Dropdown.Item
                                    className="pu-action-item monthly-devs.update"
                                    onClick={() => {
                                      this.Approve(item.uid);
                                    }}
                                  >
                                    <span className="icon">{""}</span>Approve
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            )}
                          </td>
                        )}
                      </tr>
                    );
                  })}
                  {rows.length === 0 && (
                    <tr>
                      <td colSpan={colCount} className="text-center py-5">
                        <div className="ar-empty">
                          <span className="icon d-block mb-2">{""}</span>
                          No developer commission for {filter_year} · {filter_currency}
                        </div>
                      </td>
                    </tr>
                  )}
                  {rows.length > 0 && (
                    <tr className="ar-total">
                      <td colSpan={2}>
                        <div className="ar-month-badge">
                          <span className="ar-month-badge-total">Σ</span>
                          TOTAL
                        </div>
                      </td>
                      <td className="text-center ar-muted">{filter_year}</td>
                      <td data-label="Amount" className="text-end ar-group-start">{toFixed(sum.amount, 2)}</td>
                      <td data-label="Fee" className="text-end">{toFixed(sum.fee, 2)}</td>
                      <td data-label="Cost" className="text-end">{toFixed(sum.cost, 2)}</td>
                      <td data-label="Commission" className="text-end ar-group-start">{toFixed(sum.commission, 2)}</td>
                      <td data-label="Vat 7%" className="text-end ar-neg">{toFixed(sum.vat, 2)}</td>
                      <td data-label="Revenue" className="text-end">{toFixed(sum.revenue, 2)}</td>
                      <td></td>
                      {canAct && <td className="td-actions"></td>}
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
